export var colorMap = {
    // TODO: fix when app remove that use
    primary: 'highlight.b03',
    secondary: 'neutral.b04',
    main: 'interactive.b02',
};
